import React from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import { Col, Label, Row } from 'reactstrap';
import { getHtmlElUID } from '../../../utils/helpers';
import Constants from '../../../Constants';
import { identity } from 'ramda';

const { layoutGridSize, formLabelSize, formLabelSizeSm } = Constants;

class MobileInput extends React.Component {
  handleOnChange = (value) => {
    value = value.replace(/[&\\#,-/ /()$~%.'":*?<>{}]/g, '').trim();
    this.props.onInputChange(this.props, value);
  };

  render() {
    const error = this.props.errorMessages;
    const errorClass = this.props.errorMessages ? 'border-error-mobile' : '';

    const inputProps = {
      ...(this.props.autoComplete ? { autoComplete: 'tel' } : {}),
    };

    const {
      required,
      labelSize = formLabelSize,
      keepLabelTopAligned = true,
      unlinkLabel,
      title,
    } = this.props;
    const elUID = getHtmlElUID('lsn-form-input-');

    const controlSize = (layoutGridSize - labelSize) || layoutGridSize;
    const controlSizeSm = layoutGridSize - formLabelSizeSm;

    return (
      <div className={this.props.classNames}>
        <Row className={["lsn-form-label-control relative", keepLabelTopAligned ? null : 'v-middle-align'].filter(identity).join(' ')}>
          <Label
            for={unlinkLabel ? '' : elUID}
            className={['lsn-form-label ScalaSansOT', keepLabelTopAligned ? 'mTop-6' : null].filter(identity).join(' ')}
            sm={formLabelSizeSm}
            md={labelSize}>
            {required ? <span className="lsn-red pRight-3">*</span> : null}
            {title}
          </Label>

          <Col sm={controlSizeSm} md={controlSize} className={'input-left ' + (errorClass || '')}>
            <ReactPhoneInput
              disabled={this.props.disabled}
              onChange={this.handleOnChange}
              value={this.props.value}
              placeholder='+1 (702) 123-4567'
              renderStringAsFlag=' '
              inputProps={{
                ...inputProps,
                id: elUID,
                type: "tel",
                autoComplete: "tel",
                className: 'input',
                'aria-invalid': !!error,
                'aria-describedby': !!error ?`${elUID}_error` : '',
                required,
                title,
              }}
            />
            <div className='height-25 v-align-top'>
              <span hidden={!error} id={`${elUID}_error`} className='input-error' role="alert">
                Mobile number must be 10 digits
              </span>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default MobileInput;
